import { useAccount } from '@/hooks/useAccount';

import { BODY_SHAPE_OPTIONS } from '../Layouts/OwnAIMan_TM/screens/BodyShape/BODY_SHAPE_OPTIONS';
import { BodyShapeOptionIdType } from '../Layouts/OwnAIMan_TM/screens/BodyShape/types';

const DEFAULT_BODY_SHAPE: BodyShapeOptionIdType = 'tone';

const getBodyShapeIdByTitle = (
  title: string | null | undefined,
): BodyShapeOptionIdType => {
  const option = BODY_SHAPE_OPTIONS.find((opt) => opt.title === title);
  return option?.id || DEFAULT_BODY_SHAPE;
};

export const useTMLayoutSelections = () => {
  const { user } = useAccount();

  const bodyShape = getBodyShapeIdByTitle(user?.onboarding_data?.body_shape);

  return {
    bodyShape,
  };
};
